import React from "react";
import { Tone } from "../../types/domain";
import { BoxIcon } from "lucide-react";
const toneMap: Record<Tone, {
  icon: string;
  bar: string;
}> = {
  green: {
    icon: 'bg-emerald-50 text-emerald-700',
    bar: 'bg-emerald-600'
  },
  red: {
    icon: 'bg-red-50 text-red-700',
    bar: 'bg-red-600'
  },
  orange: {
    icon: 'bg-amber-50 text-amber-700',
    bar: 'bg-amber-500'
  },
  blue: {
    icon: 'bg-blue-50 text-blue-700',
    bar: 'bg-blue-600'
  },
  gray: {
    icon: 'bg-navy-50 text-navy-800',
    bar: 'bg-navy-800'
  }
};
interface StatCardProps {
  label: string;
  value: string;
  icon: BoxIcon;
  tone?: Tone;
  sub?: string;
  onClick?: () => void;
}
export function StatCard({
  label,
  value,
  icon: Icon,
  tone = 'gray',
  sub,
  onClick
}: StatCardProps) {
  const t = toneMap[tone];
  const Comp = onClick ? 'button' : 'div';
  return <Comp onClick={onClick} className={`relative overflow-hidden rounded-lg border border-border bg-card p-4 text-left shadow-sm ${onClick ? 'transition hover:border-navy-300 hover:shadow focus-visible:outline focus-visible:outline-2' : ''}`} data-id="element-168" data-mp="1nsgqdm6iirpb">
      <span className={`absolute inset-y-0 left-0 w-1 ${t.bar}`} aria-hidden data-id="element-169" data-mp="3jv4vb1otg26u" />
      <div className="flex items-start justify-between gap-3" data-id="element-170" data-mp="3omd5w11vttll">
        <div data-id="element-171" data-mp="3oozkulr3rbdu">
          <p className="text-[13px] font-medium text-muted-foreground" data-id="element-172" data-mp="3tlzsv27iio7l">{label}</p>
          <p className="mt-1.5 font-heading text-2xl font-bold tracking-tight text-navy-900" data-id="element-173" data-mp="3to2fdc9ghz7k">{value}</p>
          {sub && <p className="mt-1 text-xs text-muted-foreground" data-id="element-174" data-mp="30xc3ovjn7eor">{sub}</p>}
        </div>
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${t.icon}`} data-id="element-175" data-mp="30zesxdcz13sf">
          <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} data-id="element-176" data-mp="35yhyr00rze1g" />
        </span>
      </div>
    </Comp>;
}